export const isNewMessage = ({ newItems, id }: { newItems: string[]; id: string }) => newItems.includes(id)
